import { stubPaths } from './utils/erp-modules.js';

const routes = {
  '/':                    () => import('./views/dashboard.js').then(m => m.initDashboard),
  '/desk/decisions':      () => import('./views/desk.js').then(m => m.initDesk),
  '/desk/my-tasks':       () => import('./views/desk.js').then(m => m.initDesk),
  '/desk/signals':        () => import('./views/desk.js').then(m => m.initDesk),
  '/my-day':              () => import('./views/my-day.js').then(m => m.initMyDay),
  '/gantt':               () => import('./views/gantt.js').then(m => m.initGantt),
  '/resources':           () => import('./views/resources.js').then(m => m.initResources),
  '/volume':              () => import('./views/volume.js').then(m => m.initVolume),
  '/fever':               () => import('./views/fever.js').then(m => m.initFever),
  '/pipeline':            () => import('./views/pipeline.js').then(m => m.initPipeline),
  '/contractor-updates':  () => import('./views/contractor-updates.js').then(m => m.initContractorUpdates),
  '/audit':               () => import('./views/audit.js').then(m => m.initAudit),
  '/calibration':         () => import('./views/calibration.js').then(m => m.initCalibration),
  '/admin':               () => import('./views/admin.js').then(m => m.initAdmin),
  '/tenders':             () => import('./views/tenders.js').then(m => m.initTenders),
  '/director/tender-funnel':() => import('./views/tender-funnel.js').then(m => m.initTenderFunnel),
  '/projects/expertise':  () => import('./views/expertise.js').then(m => m.initExpertise),
  '/projects/sheets':     () => import('./views/sheets.js').then(m => m.initSheets),
  '/projects/norm-control':() => import('./views/normcontrol.js').then(m => m.initNormControl),
  '/admin/counterparties':() => import('./views/counterparties.js').then(m => m.initCounterparties),
};

// Заглушки ERP-разделов (UI-1): все пункты дерева utils/erp-modules.js без view.
const stubLoader = () => import('./views/stub.js').then(m => m.initStub);
for (const path of stubPaths()) {
  if (!routes[path]) routes[path] = stubLoader;
}

// Deep-link'и с id сущности: /gantt/:id, /tenders/:id (ссылки из дайджеста в Telegram).
const DEEP_LINK = /^\/(gantt|tenders)\/(\d+)$/;

export function getBasePath(rawPath) {
  const path = String(rawPath ?? '/').split('?')[0];   // ?status=… — фильтры view
  const deep = path.match(DEEP_LINK);
  if (deep) return '/' + deep[1];
  if (path === '/dashboard') return '/';          // алиас из дерева модулей ERP
  return routes[path] ? path : '/';
}

async function navigate(rawPath) {
  const path     = rawPath || '/';
  const basePath = getBasePath(path);
  const loader   = routes[basePath] ?? routes['/'];
  const main     = document.getElementById('app-main');
  if (!main) return;

  main.innerHTML = '<div class="loading-spinner">Загрузка...</div>';

  // Сайдбар и шапка (вкладки активного модуля) подписаны на это событие;
  // шапка перерисовывает .header-nav до подсветки активной вкладки ниже.
  document.dispatchEvent(new CustomEvent('ccpm:navigate', { detail: { path, basePath } }));

  document.querySelectorAll('.header-nav a').forEach(a => {
    a.classList.toggle('active', a.dataset.route === basePath);
  });

  try {
    const initFn     = await loader();
    const entityId   = path.split('?')[0].match(DEEP_LINK)?.[2];
    main.innerHTML   = '';
    await initFn(main, entityId ? Number(entityId) : null);
  } catch (e) {
    console.error('Router error:', e);
    main.innerHTML = `<div class="loading-spinner" style="color:var(--text-danger)">
      Ошибка загрузки: ${e.message}
    </div>`;
  }
}

export const router = {
  init() {
    window.addEventListener('popstate', () => navigate(location.pathname + location.search));

    document.addEventListener('click', e => {
      const link = e.target.closest('[data-route]');
      if (!link) return;
      e.preventDefault();
      const path = link.dataset.route;
      history.pushState(null, '', path);
      navigate(path);
    });

    navigate(location.pathname + location.search);
  },

  push(path) {
    history.pushState(null, '', path);
    navigate(path);
  },
};
